import { lazy } from '@/service/lazy'

export default [{
  name: 'Comerciais',
  path: 'comerciais',
  id: 'comerciais',
  icon: 'fa fa-user-plus',
  component: lazy('app/default/gerenciador/vendedor/index'),
  meta: { requireAuth: true, rules: ['gerenciar_vendedor'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/vendedor.js